import { useMemo } from "react";
import { Chips } from 'primereact/chips';
import { PositiveItem } from "../../types/positiveItem";
import { Defect } from "../../types/defect";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectPhotoFolders } from "../../store/selectors/inspectionSelectors";
import { getPhotoFolderValues } from "../../utils/imageHelper";

export const PhotoFolderBody = (item: Defect | PositiveItem) => {
    const photoFolders = useAppSelector(selectPhotoFolders);

    const photoFolderValues = useMemo(() => (
        getPhotoFolderValues(photoFolders, item.photoFolder).map((photoFolder) => photoFolder.Name)
    ), [item.photoFolder]);

    return (
        <Chips value={photoFolderValues} disabled />
    );
};